import React from 'react';
import {
  PieChart, Pie, ResponsiveContainer, Cell, Legend,
} from 'recharts';
import useManagedAccountPageEventLogger
  from 'Views/Page/Content/Templates/ManagedAccountPageTemplate/managedAccountPage.eventLogging';
import useAllocationModelChartData from './useAllocationModelChartData';

export default function ManagedAccountAllocationPieChart({ managedAccount }) {
  const { classifications } = useAllocationModelChartData({ managedAccount });

  const { logAllocationPieChart } = useManagedAccountPageEventLogger();

  function handleChartClick(_, index) {
    logAllocationPieChart('Sector', {
      name: classifications[index].type,
    });
  }

  function handleLegendClick(_, index) {
    logAllocationPieChart('Legend', {
      name: classifications[index].type,
    });
  }

  return <>
    <ResponsiveContainer aspect={1}>
      <PieChart>
        <Pie
          data={classifications}
          dataKey="value"
          cx="50%"
          cy="50%"
          innerRadius={90}
          outerRadius={125}
          legendType="circle"
          startAngle={90}
          endAngle={450}
          strokeWidth={0}
          onClick={handleChartClick}
        >
          {classifications.map((entry) => <>
            <Cell key={entry.name} fill={entry.color} />
          </>)}
        </Pie>
        <Legend
          align="center"
          verticalAlign="middle"
          layout="vertical"
          itemSorter={'dataKey'}
          onClick={handleLegendClick}
        />
      </PieChart>
    </ResponsiveContainer>

  </>;
}
